// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("./image.res.js");
var CheckboxInput$ReactHooksTemplate = require("./CheckboxInput.res.js");

function MultiSelectDropDown(props) {
  var __multiSelect = props.multiSelect;
  var __width = props.width;
  var handleChange = props.handleChange;
  var selectedOptions = props.selectedOptions;
  var width = __width !== undefined ? __width : "w-3/5";
  var multiSelect = __multiSelect !== undefined ? __multiSelect : true;
  var match = React.useState(function (param) {
        return false;
      });
  var setToggleOptions = match[1];
  var toggleOptions = match[0];
  var handleOptionChange = function (option) {
    if (multiSelect) {
      if (Belt_List.has(selectedOptions, option, (function (a, b) {
                return a === b;
              }))) {
        return Curry._1(handleChange, Belt_List.keep(selectedOptions, (function (x) {
                          return x !== option;
                        })));
      } else {
        return Curry._1(handleChange, Belt_List.concat(selectedOptions, {
                        hd: option,
                        tl: /* [] */0
                      }));
      }
    } else {
      return Curry._1(handleChange, {
                  hd: option,
                  tl: /* [] */0
                });
    }
  };
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: selectedOptions === /* [] */0 ? props.defaultPlaceholder : $$Array.of_list(Belt_List.map(selectedOptions, (function (option) {
                                                  return JsxRuntime.jsxs("div", {
                                                              children: [
                                                                JsxRuntime.jsx("div", {
                                                                      children: JsxRuntime.jsx("div", {
                                                                            children: option,
                                                                            className: "text-sm truncate"
                                                                          }),
                                                                      className: "flex min-w-0"
                                                                    }),
                                                                JsxRuntime.jsx("div", {
                                                                      children: JsxRuntime.jsx("img", {
                                                                            className: "h-6-px",
                                                                            src: Image$ReactHooksTemplate.closeIcon
                                                                          }),
                                                                      className: "flex items-center justify-end flex-shrink-0",
                                                                      onClick: (function (param) {
                                                                          handleOptionChange(option);
                                                                        })
                                                                    })
                                                              ],
                                                              className: "flex gap-1 py-1 px-2 border border-gray-400 rounded justify-between max-w-full"
                                                            });
                                                }))),
                                    className: "flex gap-1 flex-wrap min-w-0 flex-1 overflow-y-auto max-h-8-rem"
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: toggleOptions ? JsxRuntime.jsx("img", {
                                            className: "h-7-px w-7-px",
                                            src: Image$ReactHooksTemplate.chevronUp
                                          }) : JsxRuntime.jsx("img", {
                                            className: "h-7-px w-7-px filter-gray-400",
                                            src: Image$ReactHooksTemplate.chevronDown
                                          }),
                                    className: "flex items-start mt-2 justify-end cursor-pointer flex-shrink-0",
                                    onClick: (function (param) {
                                        Curry._1(setToggleOptions, (function (param) {
                                                return !toggleOptions;
                                              }));
                                      })
                                  })
                            ],
                            className: "flex justify-between w-full min-w-0 gap-1"
                          }),
                      JsxRuntime.jsx("div", {
                            children: $$Array.of_list(Belt_List.map(props.options, (function (option) {
                                        return JsxRuntime.jsx("li", {
                                                    children: JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                                          checked: Belt_List.has(selectedOptions, option, (function (a, b) {
                                                                  return a === b;
                                                                })),
                                                          label: option,
                                                          handleChange: (function (param) {
                                                              handleOptionChange(option);
                                                            }),
                                                          checkboxClassName: "custom_checkbox",
                                                          labelClassName: "text-sm break-words"
                                                        }),
                                                    className: "multi-select-dropdown-option"
                                                  });
                                      }))),
                            className: "flex flex-col border z-50 bg-white cursor-pointer rounded overflow-y-auto " + (
                              toggleOptions ? "block" : "hidden"
                            ),
                            style: {
                              left: "0",
                              maxHeight: "40vh",
                              position: "absolute",
                              top: "100%",
                              width: "100%"
                            }
                          })
                    ],
                    className: "flex flex-col border px-2 py-1 border-gray-400 min-h-38-px max-h-8-rem\n                bg-white rounded capitalize text-sm multi-select-dropdown min-w-0 " + width,
                    tabIndex: 100,
                    onFocus: (function (param) {
                        Curry._1(setToggleOptions, (function (param) {
                                return true;
                              }));
                      }),
                    onBlur: (function (param) {
                        Curry._1(setToggleOptions, (function (param) {
                                return false;
                              }));
                      })
                  }),
              className: "relative w-full min-w-0"
            });
}

var make = MultiSelectDropDown;

exports.make = make;
/* react Not a pure module */
